import iceCream from "../images/icon/Cone.svg";
import Slush from "../images/icon/Slush.svg";
import Muffin from "../images/icon/Cupcake.svg";
import Pancakes from "../images/icon/Pancake.svg";
import { Link } from "react-router-dom";

const categories = [
  {
    label: "Slushees",
    note: "Big flavour, ice cold",
    image: Slush,
    path: "/slushees",
    className: "icon-category-slush",
  },
  {
    label: "Ice cream",
    note: "Smooth, sweet and dreamy",
    image: iceCream,
    path: "/menu",
    className: "icon-category-ice",
  },
  {
    label: "Muffins",
    note: "Freshly baked favourites",
    image: Muffin,
    path: "/menu/hot-desserts",
    className: "icon-category-muffin",
  },
  {
    label: "Pancakes",
    note: "Stacked for sharing",
    image: Pancakes,
    path: "/menu/hot-desserts",
    className: "icon-category-pancake",
  },
];

export default function IconBar() {
  return (
    <section className="IconRow">
      <div className="icon-row-inner">
        {categories.map((category) => (
          <Link
            to={category.path}
            className={`icon-category ${category.className}`}
            key={category.label}
          >
            <span className="icon-category-art">
              <img src={category.image} alt="" />
            </span>
            <span className="icon-category-copy">
              <strong>{category.label}</strong>
              <small>{category.note}</small>
            </span>
            <span className="icon-category-arrow" aria-hidden="true">
              ↗
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
